import { ToggleButton, ToggleButtonGroup, Box } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import { theme } from 'src/providers/ThemeProvider'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    color: theme.colors.gray14,
    marginRight: '16px'
  },
  toggleButtons: {
    '& .MuiToggleButton-root': {
      minWidth: '32px',
      height: '32px',
      fontSize: '12px',
      '&:hover': {
        backgroundColor: theme.colors.blue07
      },
      '&.Mui-selected': {
        backgroundColor: theme.corporate.primaryColor,
        color: theme.corporate.secondaryColor,
        '&:hover': {
          backgroundColor: theme.corporate.primaryColor
        },
        '&.Mui-disabled': {
          backgroundColor: theme.colors.blue06
        }
      },

      '&:first-of-type': {
        borderRadius: '8px 0 0 8px'
      },

      '&:last-child': {
        borderRadius: '0 8px 8px 0'
      }
    }
  }
}

const ToggleButtonOptions = ['Sí', 'No']

type Props = {
  id: string
  label?: string | null
  options?: string[]
  disabled?: boolean
}

function LexnetToggleButton({
  id,
  options = ToggleButtonOptions,
  label = null,
  disabled = false
}: Props): JSX.Element {
  const { setFieldValue } = useFormikContext()
  const [fieldInfo] = useField(id)
  function handleOnChange(e): void {
    setFieldValue(id, e.target.value)
  }

  return (
    <Box component="div" sx={styles.container}>
      {label && (
        <Box component="div" sx={styles.label}>
          {label}
        </Box>
      )}
      <Box component="div" sx={styles.toggleButtons}>
        <ToggleButtonGroup
          value={fieldInfo.value}
          onChange={handleOnChange}
          exclusive
          disabled={disabled}
        >
          {options.map(option => (
            <ToggleButton value={option} key={option}>
              {option}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Box>
  )
}

export default LexnetToggleButton
